import ColumnChart from '../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function ReturnRatio ({ data: returnRatio }) {
  if (!returnRatio || Object.keys (returnRatio).length === 0) {
    return null
  }

  return (
    <InfoContainer style={{height: 'auto'}}>
      <SubTitle>Taxa de retorno (com base no mês anterior)</SubTitle>
      <ColumnChart
        data={returnRatio}
        legendPosition='top'
        options={{
          height: 350,
          colors: ['#44CF6C'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Taxa de retorno (%)',
            minValue: 0,
            titleTextStyle: { bold: true }
          }
        }}
      />
    </InfoContainer>
  )
}
